<template>
  <v-dialog v-model="dialog" width="1000" scrollable persistent>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <edit-icon-button v-if="isEdit"></edit-icon-button>
        <add-button v-else></add-button>
      </span>
    </template>
    <v-card>
      <v-card-title>
        {{ isEdit ? "Update Condition" : "Add Condition" }}
      </v-card-title>
      <v-card-text class="pt-2">
        <v-form ref="form" v-model="isValid">
          <div class="subtitle-1 black--text">WHEN</div>
          <v-row v-for="(item, i) in form.conditions" :key="i">
            <v-col cols="12" md="3">
              <autocomplete
                label="Field"
                :items="fields"
                :isTemplate="false"
                @input="form.conditions[i].value = ''"
                rules="required"
                v-model="form.conditions[i].field"
              />
            </v-col>
            <v-col cols="12" md="3">
              <select-field
                label="Condition"
                rules="required"
                :items="conditionTypes"
                v-model="form.conditions[i].condition"
              />
            </v-col>
            <v-col cols="12" md="6" class="d-flex">
              <v-row v-if="isBetween(item)">
                <v-col class="py-0">
                  <time-picker
                    label="Start"
                    rules="required"
                    v-model="form.conditions[i].start"
                  />
                </v-col>
                <v-col class="py-0">
                  <time-picker
                    label="End"
                    rules="required"
                    v-model="form.conditions[i].end"
                  />
                </v-col>
              </v-row>
              <template v-else>
                <template-input
                  :isRequired="true"
                  style="width: 100%;"
                  :form="conditionForm"
                  v-if="getField(form.conditions[i].field)"
                  v-model="form.conditions[i].value"
                  :item="getField(form.conditions[i].field)"
                />
              </template>
              <delete-icon-button
                v-if="form.conditions.length != 1 && isAdmin"
                @click="form.conditions.splice(i, 1)"
              ></delete-icon-button>
            </v-col>
          </v-row>
          <add-button v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher" @click="addNewCondition()">Add Condition</add-button>
          <v-divider class="my-3"></v-divider>
          <div class="subtitle-1 black--text">THEN</div>
          <v-row v-for="(item, i) in form.perform" :key="'perform-' + i">
            <v-col cols="12" md="6">
              <autocomplete
                label="Field"
                :isTemplate="false"
                rules="required"
                :items="fields"
                v-model="form.perform[i].field"
              />
            </v-col>
            <v-col cols="12" md="6" class="d-flex">
              <template-input
                style="width: 100%;"
                :form="performForm"
                v-if="getField(form.perform[i].field)"
                v-model="form.perform[i].value"
                :item="getField(form.perform[i].field)"
                :isRequired="true"
              />

              <delete-icon-button
                @click="form.perform.splice(i, 1)"
                v-if="form.perform.length != 1 && isAdmin"
              ></delete-icon-button>
            </v-col>
          </v-row>
          <add-button v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher"  @click="addNewPerform()">Add Perform</add-button>
        </v-form>
      </v-card-text>
      <v-card-actions class="pr-5">
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false" :disabled="loading"
          >Cancel</v-btn
        >
        <v-btn
          text
          color="green"
          @click="submit()"
          v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher"
          :loading="loading"
          >Submit</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Autocomplete from "../../ui/form/Autocomplete.vue";
import AddButton from "../../buttons/AddButton.vue";
import EditIconButton from "../../buttons/EditIconButton.vue";
import TimePicker from "../../TimePicker.vue";
import DeleteIconButton from "../../ui/btns/DeleteIconButton.vue";
import SelectField from "../../ui/form/SelectField.vue";
import { fieldConditions } from "../../../assets/js/firebase";
import { getDate } from "../../../assets/js/common";
import TemplateInput from "../../customers/create/TemplateInput.vue";
export default {
  components: {
    AddButton,
    SelectField,
    EditIconButton,
    DeleteIconButton,
    TimePicker,
    Autocomplete,
    TemplateInput,
  },
  props: {
    isEdit: Boolean,
    item: Object,
  },
  data() {
    return {
      dialog: false,
      isValid: false,
      loading: false,
      conditionTypes: ["IS EQUAL TO", "TIME BETWEEN"],
      form: {
        conditions: [
          {
            field: "",
            value: "",
            condition: "IS EQUAL TO",
            start: "",
            end: "",
          },
        ],
        perform: [
          {
            field: "",
            value: "",
          },
        ],
      },
    };
  },
  computed: {
    fields() {
      let globalFields = this.$store.getters.globalFields;
      let serviceFields = this.$store.getters.serviceFields;
      return [...globalFields, ...serviceFields].map((i) => ({
        ...i,
        value: i.id,
      }));
    },
    conditionForm() {
      let doc = {};
      this.form.conditions.forEach((i) => {
        doc[i.field] = i.value;
      });
      return doc;
    },
    performForm() {
      let doc = {};
      this.form.perform.forEach((i) => {
        doc[i.field] = i.value;
      });
      return doc;
    },
  },
  watch: {
    dialog(val) {
      if (val && this.isEdit) {
        this.form.conditions = JSON.parse(JSON.stringify(this.item.conditions));
        this.form.perform = JSON.parse(JSON.stringify(this.item.perform));
      }
    },
  },
  methods: {
    getField(id) {
      let field = this.fields.find((i) => i.id == id);
      return { ...field, name: "Value" };
    },
    addNewCondition() {
      this.form.conditions.push({
        field: "",
        value: "",
        condition: "IS EQUAL TO",
        start: "",
        end: "",
      });
    },
    addNewPerform() {
      this.form.perform.push({
        field: "",
        value: "",
      });
    },
    isBetween({ condition }) {
      return condition == "TIME BETWEEN";
    },

    arraysEqual(arr1, arr2) {
      function normalizeObject(obj) {
        return Object.keys(obj)
          .sort()
          .reduce((acc, key) => {
            acc[key] = obj[key];
            return acc;
          }, {});
      }

      if (arr1.length !== arr2.length) return false;

      const sortedArr1 = arr1
        .map(normalizeObject)
        .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
      const sortedArr2 = arr2
        .map(normalizeObject)
        .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));

      return JSON.stringify(sortedArr1) === JSON.stringify(sortedArr2);
    },

    async submit() {
      this.$refs.form.validate();
      if (!this.isValid) return;
      let conditionFields = this.form.conditions.map((i) => i.field);
      let performFields = this.form.perform.map((i) => i.field);
      if (new Set(conditionFields).size !== conditionFields.length) {
        this.$alert.show(
          "The Condition should not include the same field multiple times."
        );
        return;
      }
      if (new Set(performFields).size !== performFields.length) {
        this.$alert.show(
          "The Perform should not include the same field multiple times."
        );
        return;
      }
      try {
        let doc = {
          ...this.form,
          updatedAt: getDate(),
        };
        let item = this.fieldConditions.find((i) => {
          let isConditionSame = this.arraysEqual(i.conditions, doc.conditions);
          let isPerform = this.arraysEqual(i.perform, doc.perform)
        
          // if (isPerform && isConditionSame) {
          //   return 
          // }
          // console.log("i----------iiii", i);
          // console.log("doc----------doc", doc);
          
          return isConditionSame && isPerform;
        });
        if (item != null && (!this.isEdit || item.id != this.item.id)) {
          this.$alert.show("A condition with the same details already exists.");
          return;
        }

        this.loading = true;
        if (this.isEdit) {
          await fieldConditions.doc(this.item.id).update(doc);
        } else {
          await fieldConditions.add({ ...doc, createdAt: getDate() });
        }
        this.loading = false;
        this.dialog = false;
        this.form = {
          conditions: [
            {
              field: "",
              value: "",
              condition: "IS EQUAL TO",
              start: "",
              end: "",
            },
          ],
          perform: [
            {
              field: "",
              value: "",
            },
          ],
        };
      } catch (error) {
        this.loading = false;
        this.$alert.show(error.message);
      }
    },
  },
};
</script>

<style></style>
